import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function WindowsCloudVPS() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Windows Cloud VPS Hosting | Fast SSD & RDP Access"; 
    sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Windows Cloud VPS Hosting | Fast SSD & RDP Access</title>
        <meta name="description" content="Get powerful Windows Cloud VPS hosting with SSD speed, full admin control, high bandwidth, and reliable managed support. Launch instantly." />
        <meta name="keywords" content="Cloud VPS Windows Server, VPS Windows Cloud, Windows VPS Cloud Hosting, Windows-Cloud-VPS" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/windows-cloud-vps`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/windows-cloud-vps`} />
        <meta property="og:title" content="Efficient Windows Cloud VPS Hosting for Big Enterprises" />
        <meta property="og:description" content="Unleash security & flexibility with advanced Windows Cloud VPS solutions. Ideal for big enterprises, this solution provides scalable assets & high performance." />
    </Helmet>
      <section className="banner-bg bg-dark server-banner special-tilt-pb">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-xl-6">
                    <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Enterprise Power, Simplified
                    </span>
                    <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Why Settle for Less? Control with Windows Cloud VPS!
                    </h1>
                    <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Get the freedom that you want with a Windows Cloud VPS that is active just like you. If you are scaling up or just starting, get blazing-fast speed, unwavering security, and zero fuss - all in one robust, cloud-based space customized for your next move.
                    </p>
                    <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                           </button>
                          <MinPlanPrice category="windows-cloud-vps" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                    <img src="/images/why-settle-for-less.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                </div>
            </div>
        </div>
      </section>
      <section className="domain-container position-relative z-1 overflow-hidden pb-100 special-domain-container">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                        <div className="card-body pt-60 pb-60">
                            <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-10 col-xl-9">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Our Server's Locations.</span>
                                      <h4 className="mb-4">
                                          Worldwide Spots&nbsp;
                                      </h4>
                                  </div>
                                  <div className="row mt-5 pt-3">
                                    <div className="col-md-4">
                                      <div className="country-img-card">
                                        <img src="images/us.webp" className="img-fluid full-width-img" alt="" />
                                      </div>
                                    </div>
                                    <div className="col-md-4 ipad-mini-mt">
                                      <div className="country-img-card">
                                        <img src="images/uk.webp" className="img-fluid full-width-img" alt="" />
                                      </div>
                                    </div>
                                    <div className="col-md-4 ipad-mini-mt">
                                      <div className="country-img-card">
                                        <img src="images/singapore.webp" className="img-fluid full-width-img" alt="" />
                                      </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                      <div className="country-img-card">
                                        <img src="images/japan.webp" className="img-fluid full-width-img" alt="" />
                                      </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                      <div className="country-img-card">
                                        <img src="images/sydney.webp" className="img-fluid full-width-img" alt="" />
                                      </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                      <div className="country-img-card">
                                        <img src="images/germany.webp" className="img-fluid full-width-img" alt="" />
                                      </div>
                                    </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="price-plan-section pt-100 pb-100">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
            <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Beyond Our Hosting, It's Your Growth</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'windows-cloud-vps'}/>
      </section>
      <section className="pt-100 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-8">
                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Runs on Windows & Here Too.</span>
                    <h2 className="mb-0">Get A Lot More Than You Bargained For with Our VPS!</h2>
                </div>
            </div>
            <div className="pt-40">
                <div className="row g-4">
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-custom-6 bg-white px-8 py-10 rounded-3 h-100">
                            <img src="images/support-never.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Support: Never Ghosts</h5>
                            <p className="text-dark mb-0">Need support mid-day or night? We’re right here-don’t overthink, don’t wait, don’t pay extra. Our support experts have got you, always on, always genuine.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-custom-6 bg-white px-8 py-10 rounded-3 h-100">
                            <img src="images/slide-into-our.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Slide Into Our Support, 24/7</h5>
                            <p className="text-dark mb-0">Stuck or exhausted? Just ping us on MS Teams-there we’re available 24/7, ready to contact instantly and fix your issue. Not just tech talk, but also real help from experts.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-custom-6 bg-white px-8 py-10 rounded-3 h-100">
                            <img src="images/sites-that-never.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Sites That Never Go Down</h5>
                            <p className="text-dark mb-0">Are you tired of sites that go down when high traffic hits? With the help of our 99.9% uptime and Windows Cloud VPS, you're always up, always available.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-custom-6 bg-white px-8 py-10 rounded-3 h-100">
                            <img src="images/lag-not-with.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Lag? Not With Our Network</h5>
                            <p className="text-dark mb-0">Your site’s speed is not the right place to test your visitors’ patience. With an amazing 100 MBPS network on our Windows Cloud VPS, you’ll speed up every scroll & have no loss.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-custom-6 bg-white px-8 py-10 rounded-3 h-100">
                            <img src="images/back-it-up.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Back It Up Like a Real Boss</h5>
                            <p className="text-dark mb-0">With our automatic backups, your site’s data stays locked down and secure. Select your vibe by yourself-daily, weekly, or monthly-and rest without stress!</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-custom-6 bg-white px-8 py-10 rounded-3 h-100">
                            <img src="images/tech-that-hits.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Tech That Hits Different</h5>
                            <p className="text-dark mb-0">Ready to experience the next level of performance? Our Windows VPS servers usually come with modern tools. Get ASP, ASP.NET, PHP, IIS, and MySQL support.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
        <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
        <div className="pb-40">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-7">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <span className="section-title-dark style-bg fadeInUp">Features</span>
                            <h2 className="text-white">
                                Windows VPS Server Features Revealed!
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container all-feature-container">
            <div className="row">
              <div className="col-12">
                  <div className="feature-tabbing-main mt-4">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Unlimited SQL Databases</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Enterprise Hardware</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Remote Desktop Access</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Unlimited Email Accounts</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Premium Network</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Run ASP/.NET Website</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Enhanced Security</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Upgrade At Anytime</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Free Website Migration</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Windows Server 2016 / 2019</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Supports all MVC Frameworks</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Host Unlimited Domains</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Private Name Servers</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-2">
                          <div className="feature-wrapper h-100">
                              <p><span className="tab-check-icon"><i className="fa-solid fa-check-double"></i></span>Guaranteed Resources</p>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </section>
      <section className="service-area pt-100 pb-100">
        <div className="pb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-7">
                        <span className="section-title style-bg fadeInUp">Your True Friend</span>
                        <h2 className="mb-0" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200"
                            data-sal-easing="ease-in-out-sine">Your IT Best Friend, All in One Place</h2>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                            <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                        <div className="card-body px-md-7 py-md-8">
                            <div className="row align-items-center g-4 d-grid">
                                <div className="col-md-4">
                                    <img className="service-img" src="images/full-access.webp" alt="" />
                                </div>
                                <div className="col-md-12">
                                    <h6 className="mb-4">Full Access, Full Control</h6>
                                    <p className="mb-5 pb-2">Run it in the way you want with full access. With a VPS RDP server, peek into files, all linked devices, and networks connected with the Windows VPS server. You’re not just logging in, you’re taking control.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                        <img className="service-figure-1" src="images/feature-shape-1.webp" alt="" />
                        <div className="card-body px-md-7 py-md-8">
                            <div className="row align-items-center g-4 d-grid">
                                <div className="col-md-4">
                                    <img className="service-img" src="images/many-cpanels.webp" alt="" />
                                </div>
                                <div className="col-md-12">
                                    <h6 className="mb-4">Many CPanels, No Stress</h6>
                                    <p className="mb-5 pb-2">Why are you stuck when you can move smoothly? Choose your favorite control panel (Plesk or Solid CP) and handle your web space like an expert- websites, emails, databases... all in one user-friendly dashboard.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                        <div className="card-body px-md-7 py-md-8">
                            <h6>Personalize Everything</h6>
                            <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                <div>
                                    <img className="small-service-img" src="images/personalize.webp" alt="" />
                                </div>
                                <div>
                                    <p>Install what your business needs, scale when you want, and run things on your terms. This refers to Windows Cloud VPS freedom.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                        <div className="card-body px-md-7 py-md-8">
                            <h6>SSD = Speed Without Drama</h6>
                            <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                <div>
                                    <img className="small-service-img" src="images/ssd-speed-without.webp" alt="" />
                                </div>
                                <div>
                                    <p>Quick, seamless, and reliable - SSD (solid-state drive) storage elevates your website from boring to extraordinary in no time.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                        <div className="card-body px-md-7 py-md-8">
                            <h6>Scalable, Stable & Smart</h6>
                            <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                <div>
                                    <img className="small-service-img" src="images/scalable-stable.webp" alt="" />
                                </div>
                                <div>
                                    <p>Highly stable, grows fast-our hosting solutions scales up with you. High traffic? No worries. Keep it up as usual while scaling.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                        <div className="card-body px-md-7 py-md-8">
                            <h6>Data Centers Globally</h6>
                            <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                <div>
                                    <img className="small-service-img" src="images/data-centers.webp" alt="" />
                                </div>
                                <div>
                                    <p>Host nearer, load quicker-with multiple data centers and complete root access, run the game wherever your target audience is.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                        <div className="card-body px-md-7 py-md-8">
                            <h6>Dedicated Assets, For You</h6>
                            <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                <div>
                                    <img className="small-service-img" src="images/dedicated-assets.webp" alt="" />
                                </div>
                                <div>
                                    <p>CPU, RAM, disk space? Everything is yours. No more fighting for resources. Customize it as per your flow, your budget, and your brand.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-6">
                    <div className="card service-card-item shadow-sm rounded-3 h-100" data-sal="slide-up"
                        data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                        <div className="card-body px-md-7 py-md-8">
                            <h6>Top-Tier Security</h6>
                            <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                <div>
                                    <img className="small-service-img" src="images/top-tier.webp" alt="" />
                                </div>
                                <div>
                                    <p>Are you migrating from slow hosting? Don’t worry, just relax-we keep your site & infrastructure safe with our VPS Cloud Windows.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <div className="container pt-40 pb-80">
        <div className="bg-dark px-8 px-md-14 rounded-3 sal-animate box-padding" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
            <div className="row align-items-center g-4">
                <div className="col-xxl-6 col-xl-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <img src="images/whats-for-you-on-Infinitive-host.webp" alt="image" className="img-fluid" />
                </div>
                <div className="col-xxl-6 col-xl-8">
                    <h2 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">From Offline to Online Within No Time</h2>
                    <p className="text-white text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Speed? Power? Control? Get All With Windows Cloud VPS!</p>
                    <ul className="text-white text-opacity-75 sal-animate">
                        <li>Never Go Offline</li>
                        <li>Help when Needed</li>
                    </ul>
                    <div className="mt-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                            <span className="d-inline-block me-1 flex-shrink-0">
                                <i className="las la-comments"></i>
                            </span>
                            <span className="btn-arrow__text">
                                Live Chat Now
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}
